// extracted by mini-css-extract-plugin
export default {"wrapper__footer":"musicSkelenton_wrapper__footer__Bl5hs"};